"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnpublishedChanges = exports.syncFields = exports.deploySite = exports.getSite = exports.getSites = exports.deleteSite = exports.updateSite = exports.addSite = void 0;

var _router = require("@reach/router");

var _services = require("../services");

var _routes = _interopRequireDefault(require("../routes"));

var addSite = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var title, ownerID, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            title = _ref.title, ownerID = _ref.ownerID;
            _context.next = 3;
            return _services.siteServices.addSite({
              title: title,
              ownerID: ownerID
            }, dispatch, config);

          case 3:
            result = _context.sent;

            if (result) {
              dispatch({
                type: "ADD_SITE",
                payload: result
              });
              (0, _router.navigate)((0, _routes.default)("dashboard", {
                siteID: result.id
              }));
            }

            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addSite(_x, _x2, _x3) {
    return _ref8.apply(this, arguments);
  };
}();

exports.addSite = addSite;

var updateSite = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var id, themeOptions, frontPage, deployment, title, siteUrl, googleMapsApi, apiKey, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref2.id, themeOptions = _ref2.themeOptions, frontPage = _ref2.frontPage, deployment = _ref2.deployment, title = _ref2.title, siteUrl = _ref2.siteUrl, googleMapsApi = _ref2.googleMapsApi, apiKey = _ref2.apiKey;
            _context2.next = 3;
            return _services.siteServices.updateSite({
              id: id,
              themeOptions: themeOptions,
              frontPage: frontPage,
              deployment: deployment,
              title: title,
              siteUrl: siteUrl,
              googleMapsApi: googleMapsApi,
              apiKey: apiKey
            }, dispatch, config);

          case 3:
            result = _context2.sent;

            if (result) {
              dispatch({
                type: "ADD_SITE",
                payload: result
              });
              dispatch({
                type: "ADD_EDITOR_SITE",
                payload: result
              });
            }

            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateSite(_x4, _x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}();

exports.updateSite = updateSite;

var deleteSite = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var id, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            id = _ref3.id;
            _context3.next = 3;
            return _services.siteServices.deleteSite({
              id: id
            }, dispatch, config);

          case 3:
            result = _context3.sent;

            if (result) {
              dispatch({
                type: "DELETE_SITE",
                payload: result
              });
            }

            return _context3.abrupt("return", result);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteSite(_x7, _x8, _x9) {
    return _ref10.apply(this, arguments);
  };
}();

exports.deleteSite = deleteSite;

var getSites = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args, dispatch, config) {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _services.siteServices.getSites(args, dispatch, config);

          case 2:
            result = _context4.sent;

            if (result) {
              dispatch({
                type: "ADD_SITES",
                payload: result
              });
            }

            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getSites(_x10, _x11, _x12) {
    return _ref11.apply(this, arguments);
  };
}();

exports.getSites = getSites;

var getSite = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4, dispatch, config) {
    var siteID, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            siteID = _ref4.siteID;
            _context5.next = 3;
            return _services.siteServices.getSite({
              siteID: siteID
            }, dispatch, config);

          case 3:
            result = _context5.sent;

            if (result) {
              dispatch({
                type: "ADD_SITE",
                payload: result
              });
            }

            return _context5.abrupt("return", result);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getSite(_x13, _x14, _x15) {
    return _ref12.apply(this, arguments);
  };
}();

exports.getSite = getSite;

var deploySite = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref5, dispatch, config) {
    var id, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            id = _ref5.id;
            _context6.next = 3;
            return _services.siteServices.deploySite({
              id: id
            }, dispatch, config);

          case 3:
            result = _context6.sent;

            if (result) {
              dispatch({
                type: 'ADD_SITE',
                payload: result
              });
            }

            return _context6.abrupt("return", result);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function deploySite(_x16, _x17, _x18) {
    return _ref13.apply(this, arguments);
  };
}();

exports.deploySite = deploySite;

var syncFields = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref6, dispatch, config) {
    var fields, apiKey, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            fields = _ref6.fields, apiKey = _ref6.apiKey;
            _context7.next = 3;
            return _services.siteServices.syncFields({
              fields: fields,
              apiKey: apiKey
            }, dispatch, config);

          case 3:
            result = _context7.sent;

            if (result) {
              dispatch({
                type: 'ADD_SITE',
                payload: result
              });
            }

            return _context7.abrupt("return", result);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function syncFields(_x19, _x20, _x21) {
    return _ref14.apply(this, arguments);
  };
}();

exports.syncFields = syncFields;

var getUnpublishedChanges = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref7, dispatch, config) {
    var siteID, result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            siteID = _ref7.siteID;
            _context8.next = 3;
            return _services.siteServices.getUnpublishedChanges({
              siteID: siteID
            }, dispatch, config);

          case 3:
            result = _context8.sent;
            return _context8.abrupt("return", result);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getUnpublishedChanges(_x22, _x23, _x24) {
    return _ref15.apply(this, arguments);
  };
}();

exports.getUnpublishedChanges = getUnpublishedChanges;